// @flow

import Tooltip, { VARIATIONS } from './Tooltip'
export { VARIATIONS }
export default Tooltip



// WEBPACK FOOTER //
// ./src/components/Tooltip/index.js